import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/Index'
import Home from '@/page/Home'
import Culture from '@/page/Culture'
import News from '@/page/News'
import Detail from '@/page/Detail'
import Contact from '@/page/Contact'

import mIndex from '@/page/m/Index'
import mHome from '@/page/m/Home'
import mNews from '@/page/m/News'
import mDetail from '@/page/m/Detail'
import mContact from '@/page/m/Contact'

Vue.use(Router)

export default new Router({
  //页面跳转显示在顶部   
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/index',
      name: 'Index',
      component: Index, 
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/culture',
      name: 'culture',
      component: Culture
    },
    {
      path: '/news',
      name: 'news',
      component: News
    }
    ,
    {
      path: '/detail/:id',
      name: 'detail',
      component: Detail
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/m/Index',
      name: 'mIndex',
      component: mIndex
    },
    {
      path: '/m/Home',
      name: 'mHome',
      component: mHome
    },
    {
      path: '/m/News',
      name: 'mNews',
      component: mNews
    },
    {
      path: '/m/Detail/:id',
      name: 'mDetail',
      component: mDetail
    },
    {
      path: '/m/Contact',
      name: 'mContact',
      component: mContact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js